import dayjs from 'dayjs';

const MIN_SUPPORTED_RANGE_DAYS = 2;

export const isRangeSupported = (from: string, to: string) =>
  dayjs(to).diff(dayjs(from), 'day', true) >= MIN_SUPPORTED_RANGE_DAYS;
